import {ITEM_TYPES} from '../../constants.js';
import {createReducer} from '@reduxjs/toolkit';
import {resetFilters, toggleType} from '../../actions/search.js';
import {trackEvent} from '../../analytics.js';

const defaultState = Object.keys(ITEM_TYPES).filter(
  type => ITEM_TYPES[type].selected,
);

export default createReducer(defaultState, builder => {
  builder.addCase(toggleType, (state, {payload}) => {
    const set = new Set(state);
    if (set.has(payload)) {
      trackEvent('Deselected item type', {itemType: payload});
      set.delete(payload);
    } else {
      trackEvent('Selected item type', {itemType: payload});
      set.add(payload);
    }
    return Array.from(set);
  });
  builder.addCase(resetFilters, () => defaultState);
});
